import { WELLO_IMAGE_PREFIX_URL } from '@/constants';

export const INFO_IMAGE = {
  url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/info.png`,
  alt: '고향사랑기부제 소개',
  width: 242,
  height: 34,
} as const;

export const BENEFIT_IMAGES = {
  panpare: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/panpare.png`,
    alt: '세액공제 혜택 아이콘',
    width: 80,
    height: 80,
  },
  giftBox: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/gift-box.png`,
    alt: '답례품 혜택 아이콘',
    width: 80,
    height: 80,
  },
  bubble: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/bubble.png`,
    alt: '무제한 뱃지',
    width: 63,
    height: 37,
  },
} as const;

export const TYPOGRAPHY_IMAGES = {
  stampHeading: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-stamp-heading.png`,
    alt: '나의 기부 스탬프 현황',
    width: 271,
    height: 38,
  },
  taxDeduction: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-tax-deduction.png`,
    alt: '세액공제 혜택',
    width: 73,
    height: 48,
  },
  premiumGift: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-premium-gift.png`,
    alt: '프리미엄 답례품',
    width: 62,
    height: 48,
  },
  welPoint2000: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-wel-point-2000.png`,
    alt: '웰포인트 2,000원',
    width: 71,
    height: 48,
  },
  welPoint1000: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-wel-point-1000.png`,
    alt: '웰포인트 1,000원',
    width: 67,
    height: 48,
  },
  unlimited: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-unlimited.png`,
    alt: '무제한',
    width: 42,
    height: 19,
  },
  challengeHeading: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-challenge-heading.png`,
    alt: '여러 지역에 기부하면 경품도 업그레이드',
    width: 287,
    height: 76,
  },
  myGiftHeading: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-my-gift-heading.png`,
    alt: '내가 받을 답례품',
    width: 217,
    height: 45,
  },
  recommendHeading: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-recommend-heading.png`,
    alt: '기부를 추천합니다',
    width: 205,
    height: 40,
  },
  howToCollectHeading: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-how-to-collect-heading.png`,
    alt: '스탬프 모으는 방법 알려드릴게요',
    width: 171,
    height: 62,
  },
  benefitSubtitle13: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-benefit-subtitle-13.png`,
    alt: '13만원 혜택',
    width: 150,
    height: 40,
  },
  benefitSubtitleSpecial: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-benefit-subtitle-special.png`,
    alt: '특별 혜택 100% 드려요',
    width: 311,
    height: 34,
  },
  buttonDonate: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-button-donate.png`,
    alt: '기부하러 가기',
    width: 146,
    height: 34,
  },
  buttonMoreGifts: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-button-more-gifts.png`,
    alt: '답례품 더 받기',
    width: 169,
    height: 34,
  },
  buttonComplete: {
    url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/typo-button-complete.png`,
    alt: '스탬프 모으기 완료',
    width: 223,
    height: 34,
  },
} as const;

export const PRIZE_DATA = {
  2: {
    label: '2곳에 기부하면',
    completedLabel: '2곳 기부 완료!',
    prize: '5만원\n백화점 상품권',
    image: {
      url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/price2.png`,
      width: 143,
      height: 110,
    },
  },
  5: {
    label: '5곳에 기부하면',
    completedLabel: '5곳 기부 완료!',
    prize: '40만원 상당\n고급 여행용 캐리어',
    prizeDetail: '(29인치)',
    image: {
      url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/price5.png`,
      width: 143,
      height: 110,
    },
  },
  7: {
    label: '7곳에 기부하면',
    completedLabel: '7곳 기부 완료!',
    prize: '60만원 상당\n다이슨 에어랩',
    image: {
      url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/price7.png`,
      width: 143,
      height: 110,
    },
  },
  10: {
    label: '10곳에 기부하면',
    completedLabel: '10곳 기부 완료!',
    prize: '100만원 상당\n국내 여행 상품권',
    image: {
      url: `${WELLO_IMAGE_PREFIX_URL}/donation/event/stamp/price10.png`,
      width: 143,
      height: 110,
    },
  },
} as const;

export const REGIONS_DATA = [
  { region: '강원', cities: '강릉' },
  { region: '충북', cities: '진천' },
  { region: '충남', cities: '당진, 논산' },
  { region: '대전', cities: '대전시청, 대전대덕' },
  { region: '경북', cities: '영주' },
  { region: '경남', cities: '통영, 거제' },
  { region: '전북', cities: '임실, 무주' },
  { region: '전남', cities: '전남도청, 영암, 영광, 완도, 고흥' },
  { region: '광주', cities: '광주서구, 광주남구, 광주북구' },
  { region: '제주', cities: '제주도청' },
] as const;

export type RegionName = (typeof REGIONS_DATA)[number]['region'];

export const LOCATION_MAP: Record<RegionName, { className: string }> = {
  강원: { className: 'absolute top-[25px] left-[219px] w-[68px] h-[91px]' },
  충북: { className: 'absolute top-[117px] left-[190px] w-[68px] h-[91px]' },
  충남: { className: 'absolute top-[156px] left-[64px] w-[68px] h-[82px]' },
  대전: { className: 'absolute top-[207px] left-[167px] w-[68px] h-[82px]' },
  경북: { className: 'absolute top-[208px] left-[273px] w-[68px] h-[91px]' },
  경남: { className: 'absolute top-[300px] left-[203px] w-[68px] h-[82px]' },
  전남: { className: 'absolute top-[375px] left-[12px] w-[68px] h-[82px]' },
  전북: { className: 'absolute top-[270px] left-[92px] w-[68px] h-[82px]' },
  광주: { className: 'absolute top-[364px] left-[95px] w-[68px] h-[91px]' },
  제주: { className: 'absolute top-[487px] left-[47px] w-[68px] h-[91px]' },
};

export const ONBOARDING_SEQUENCE: readonly RegionName[] = [
  '제주',
  '전남',
  '광주',
  '전북',
  '충남',
  '대전',
  '충북',
  '경남',
  '경북',
  '강원',
];

export const REVIEWS = [
  { text: '마음이 따뜻해지는 경험이었습니다', author: '박*진' },
  { text: '기부도 하고 답례품도 받고 마음도 뿌듯해요!', author: '박*암' },
  { text: '손해볼거없이 좋기만한 선택', author: '정*인' },
  {
    text: '쉽고 편하게 기부하고 답례품도 받을 수 있어서 좋아요!',
    author: '원*아',
  },
  { text: '일단 해보고 생각하자', author: '장*원' },
  { text: '세액공제에 선물까지 주는데 Go!', author: '김*희' },
  {
    text: '각 지역을 대표하는 특산품도 경험할 수 있는 좋은 기회',
    author: '조*심',
  },
  { text: '마음이 따뜻해지는 경험', author: '박*운' },
  { text: '일석이조의 기쁨이었어요', author: '박*예' },
  { text: '혜택도 마음도 두배로 얻을수있어요', author: '이*혜' },
  { text: '답례품도 받고 기부도 하고 기분좋아요', author: '박*수' },
  { text: '기부도 하고 훌륭한 답례품도 받고 세액 공제까지!', author: '홍*숙' },
  { text: '작지만 간편한 방법으로 뿌듯해지는 경험', author: '이*진' },
  { text: '세액공제도 되고 지역 특산품도 받아서 일석이조!', author: '허*승' },
  { text: '기부를 간편하게 할 수 있어요', author: '이*선' },
  { text: '고향을 위한다는 좋은 느낌과 좋은 답례품', author: '남*우' },
  { text: '세액공제만큼은 필수로 합시다', author: '고*진' },
  { text: '믿고 기부하자', author: '연*주' },
  {
    text: '가보지 못한 지역도 작게나마 응원할 수 있어 좋습니다',
    author: '권*은',
  },
  { text: '기부와 혜택 모두 누릴 수 있는 뿌듯한 경험', author: '김*영' },
] as const;

export const ANIMATION_CONFIG = {
  carouselRotationIntervalMs: 1500,
  transitionDurationSeconds: 0.3,
  easingCurve: [0.4, 0.0, 0.2, 1] as [number, number, number, number],
} as const;
